var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9311 17.5986C18.8639 17.5986 21.2414 14.2021 21.2414 10.0124C21.2414 5.82261 18.8639 2.42615 15.9311 2.42615C12.9982 2.42615 10.6207 5.82261 10.6207 10.0124C10.6207 14.2021 12.9982 17.5986 15.9311 17.5986Z",
    fill: "#FFB334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.069 17.5986C31.0018 17.5986 33.3793 14.2021 33.3793 10.0124C33.3793 5.82261 31.0018 2.42615 28.069 2.42615C25.1362 2.42615 22.7587 5.82261 22.7587 10.0124C22.7587 14.2021 25.1362 17.5986 28.069 17.5986Z",
    fill: "#FFB334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10345 19.1158C9.10345 23.3057 8.58303 26.702 6.06897 26.702C3.5549 26.702 0 23.3057 0 19.1158C0 14.9259 2.03766 11.5296 4.55172 11.5296C7.06579 11.5296 9.10345 14.9259 9.10345 19.1158Z",
    fill: "#FFB334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 19.1158C44.0001 23.3057 40.4452 26.702 37.9311 26.702C35.417 26.702 34.8966 23.3057 34.8966 19.1158C34.8966 14.9259 36.9343 11.5296 39.4483 11.5296C41.9624 11.5296 44.0001 14.9259 44.0001 19.1158Z",
    fill: "#FFB334"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 32.1208C34.1379 36.6657 31.7862 40.4846 26.5517 41.5672C25.5822 41.7675 23.0476 37.3227 22 37.3227C20.9523 37.3227 18.4178 41.7675 17.4483 41.5672C12.2138 40.4846 9.86206 36.6657 9.86206 32.1208C9.86206 26.7339 15.2961 19.1158 22 19.1158C28.7039 19.1158 34.1379 26.7339 34.1379 32.1208Z",
    fill: "#FFB334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8966 32.771H12.8814C12.4626 32.7627 12.1296 32.4164 12.138 31.9975C12.138 31.9974 12.138 31.9973 12.138 31.9972C12.2222 27.8088 16.6738 21.3917 22 21.3917C22.419 21.3917 22.7587 21.7313 22.7587 22.1503C22.7587 22.5692 22.419 22.9089 22 22.9089C17.5735 22.9089 13.7265 28.5098 13.6552 32.0275C13.647 32.4406 13.3098 32.7711 12.8966 32.771Z",
    fill: "#FFEEAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.333133ad06d56c4400f5cf4e182fa87c.svg";
export { ForwardRef as ReactComponent };